import {MIN_COUNT, MAX_AREA_COUNT, MAX_CATEGORY_COUNT, MAX_THING_COUNT} from "../data/constants.js";
const isValid = (order, type) => {
  switch (type) {
    case "AREA":
      return order >= MIN_COUNT && order <= MAX_AREA_COUNT;
    case "CATEGORY":
      return order >= MIN_COUNT && order <= MAX_CATEGORY_COUNT;
    case "THING":
      return order >= MIN_COUNT && order <= MAX_THING_COUNT;
    default:
      return false;
  }
};
export const createAreaJdId = (order) => {
  if (!isValid(order, "AREA"))
    return null;
  return `${order}0-${order}9`;
};
export const createCategoryJdId = (order, areaOrder) => {
  if (!isValid(order, "CATEGORY") || !isValid(areaOrder, "AREA"))
    return null;
  return `${areaOrder}${order}`;
};
export const createThingJdIdFromCategory = (order, categoryJdId) => {
  if (!isValid(order, "THING"))
    return null;
  return `${categoryJdId}.${order < 10 ? `0${order}` : order}`;
};
export const createThingJdIdFromOrders = (order, categoryOrder, areaOrder) => {
  if (!isValid(order, "THING") || !isValid(categoryOrder, "CATEGORY") || !isValid(areaOrder, "AREA"))
    return null;
  const categoryJdId = createCategoryJdId(categoryOrder, areaOrder);
  return `${categoryJdId}.${order < 10 ? `0${order}` : order}`;
};
